import React, { useState } from 'react';
import './QuickActions.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCirclePlus, faClock, faFileLines } from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import InvoiceWizard from '../../Invoice/Components/InvoiceWizard/InvoiceWizard';
import LogExpenseEntryModal from '../../Expenses/Components/LogExpenseEntryModal/LogExpenseEntryModal';
import LogBillableEntryModal from '../../Billing/Components/LogBillableEntryModal/LogBillableEntryModal';

const QuickActions: React.FC = () => {
  const { matterId } = useParams<{ matterId: string }>();
  const queryClient = useQueryClient();
  const [showCreateInvoice, setShowCreateInvoice] = useState(false);
  const [showAddExpenseModal, setShowAddExpenseModal] = useState(false);
  const [showLogBillableModal, setShowLogBillableModal] = useState(false);

  const handleAddExpense = (): void => {
    setShowAddExpenseModal(true);
  };

  const handleLogFee = (): void => {
    setShowLogBillableModal(true);
  };

  const handleExpenseModalSuccess = (): void => {
    setShowAddExpenseModal(false);
    if (matterId) {
      queryClient.invalidateQueries({ queryKey: ['fixedBillExpenses'] });
    }
  };

  const handleLogBillableModalSuccess = (): void => {
    setShowLogBillableModal(false);
    if (matterId) {
      queryClient.invalidateQueries({ queryKey: ['fixedFees'] });
    }
  };

  const handleCreateInvoice = (): void => {
    setShowCreateInvoice(true);
  };

  const handleInvoiceWizardClose = (): void => {
    setShowCreateInvoice(false);
    if (matterId) {
      queryClient.invalidateQueries({ queryKey: ['invoices', matterId] });
    }
  };

  return (
    <div className="matter-quick-actions">
      <h2 className="matter-quick-actions-title">Quick Actions</h2>
      <div className="matter-quick-actions-grid">
        <div className="matter-quick-action-item" onClick={handleAddExpense}>
          <div className="matter-quick-action-icon">
            <FontAwesomeIcon icon={faFileCirclePlus} className="matter-quick-action-fa-icon" />
          </div>
          <span className="matter-quick-action-text">Add Expense</span>
          <span className="matter-quick-action-subtitle">Record new expense</span>
        </div>
        
        <div className="matter-quick-action-item" onClick={handleLogFee}>
          <div className="matter-quick-action-icon">
            <FontAwesomeIcon icon={faClock} className="matter-quick-action-fa-icon" />
          </div>
          <span className="matter-quick-action-text">Log Fee</span>
          <span className="matter-quick-action-subtitle">Track billable time</span>
        </div>
        
        <div className="matter-quick-action-item" onClick={handleCreateInvoice}>
          <div className="matter-quick-action-icon">
            <FontAwesomeIcon icon={faFileLines} className="matter-quick-action-fa-icon" />
          </div>
          <span className="matter-quick-action-text">Create Invoice</span>
          <span className="matter-quick-action-subtitle">Generate new invoice</span>
        </div>
      </div>

      {showCreateInvoice && matterId && (
        <InvoiceWizard
          matterId={matterId}
          existingInvoice={undefined}
          onClose={handleInvoiceWizardClose}
        />
      )}

      <LogExpenseEntryModal
        isOpen={showAddExpenseModal}
        onClose={() => setShowAddExpenseModal(false)}
        onSuccess={handleExpenseModalSuccess}
        matterId={matterId}
      />

      <LogBillableEntryModal
        isOpen={showLogBillableModal}
        onClose={() => setShowLogBillableModal(false)}
        onSuccess={handleLogBillableModalSuccess}
        matterId={matterId}
      />
    </div>
  );
};

export default QuickActions;
